export default "/assets/images/milaair-order-bg.jpg?332bb368bca879397075b35d366803eb";